export default "__VITE_ASSET__BCXdLCcD__"